import { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import { selectIsEditorFocused } from '../../../../../../../store/ui/uiSelectors'
import { setFocusedEditor } from '../../../../../../../store/ui/uiSlice'
import TaskModalCommentsAddCommentPlaceholder from './components/TaskModalCommentsAddCommentPlaceholder/TaskModalCommentsAddCommentPlaceholder'
import TaskModalCommentsAddCommentEditor from './components/TaskModalCommentsAddCommentEditor/TaskModalCommentsAddCommentEditor'
import css from './TaskModalCommentsAddComment.module.css'

const EDITOR_ID = 'comment-add'

const TaskModalCommentsAddComment = () => {
    const dispatch = useAppDispatch()
    const isFocused = useAppSelector(selectIsEditorFocused(EDITOR_ID))
    // Mount the editor (hidden) once the pointer enters, so Plate spins up during hover instead
    // of adding lag/jump when the placeholder is clicked. Same trick as the task description.
    const [prewarm, setPrewarm] = useState(false)
    const showEditor = prewarm || isFocused

    return (
        <div className={css.wrapper} onMouseEnter={() => setPrewarm(true)}>
            {showEditor && (
                <div className={isFocused ? undefined : css.prewarm}>
                    <TaskModalCommentsAddCommentEditor
                        active={isFocused}
                        onClose={() => dispatch(setFocusedEditor(null))}
                    />
                </div>
            )}
            {!isFocused && (
                <TaskModalCommentsAddCommentPlaceholder onClick={() => dispatch(setFocusedEditor(EDITOR_ID))} />
            )}
        </div>
    )
}

export default TaskModalCommentsAddComment
